import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import { getAnnotators, publishAnnotator, unpublishAnnotator, republishAnnotator, updateAnnotator, previewAnnotator, previewAnnotatorClustering, changeAnnotatorOrder } from '../../utils/AnnotatorAPI';
import { getClusterers, publishClusterer, unpublishClusterer, republishClusterer, updateClusterer, previewClustererExecution, changeClustererOrder } from '../../utils/ClustererAPI';
import { getEmbeddersByUser } from '../../utils/EmbedderAPI';
import { objectToArray } from '../../utils/functions';
import PropertyValuesModal from "./modals/PropertyValuesModal.js";
import SchemaProperty from "./SchemaProperty.js";
import SchemaClass from "./SchemaClass.js";
import ResultsModal from "./modals/ResultsModal.js";
import ScoreDistributionModal from "./modals/ScoreDistributionModal.js";
import AnnotationValuesModal from "./modals/AnnotationValuesModal.js";
import ClusterValuesModal from "./modals/ClusterValuesModal.js";
import ValidationModal from "./modals/ValidationModal.js";
import VocabularyValuesModal from "./modals/VocabularyValuesModal.js";
import DownloadAnnotationsModal from "./modals/DownloadAnnotationsModal.js";
import DeleteModal from "./modals/DeleteModal.js";
import EmbedderModal from "./modals/EmbedderModal.js";
import ExecutableState from "./ExecutableState.js";
import PublishableState from "./PublishableState.js";

import { throwToast } from '../../utils/UIUtils';

import { createAnnotator, deleteAnnotator, prepareAnnotator, executeAnnotator, stopAnnotator, previewLastAnnotatorExecution, previewPublishedAnnotatorExecution, downloadLastAnnotatorExecution, downloadPublishedAnnotatorExecution, clearAnnotatorExecution } from '../../utils/AnnotatorAPI.js'
import { createClusterer, deleteClusterer, executeClusterer, stopClusterer, previewLastClustererExecution, previewPublishedClustererExecution, downloadLastClustererExecution, downloadLastClustererClustering, downloadPublishedClustererExecution, clearClustererExecution } from '../../utils/ClustererAPI.js'
import { createEmbedder, deleteEmbedder, executeEmbedder, stopEmbedder, previewLastEmbedderExecution, previewPublishedEmbedderExecution, downloadLastEmbedderExecution, downloadPublishedEmbedderExecution, publishEmbedder, unpublishEmbedder } from '../../utils/EmbedderAPI.js'
import { getDatasetSchema, getDatasetPropertyValues, downloadDatasetPropertyValues, getDatasetPropertyValueItems } from '../../utils/DatasetAPI.js'
import { downloadAnnotationValues, viewValuesAnnotations, viewAnnotationEditsExecution, scoreValidationDistribution, getAnnotationEditGroups, getAnnotationEditGroupsByUser, setAnnotationEditGroupAutoexportable, commitAnnotationEdits } from '../../utils/AnnotationEditGroupAPI.js'
import { stopPagedAnnotationValidation, resumePagedAnnotationValidation, viewAnnotationValidation, commitAnnotationValidationPage, createPagedAnnotationValidation, updatePagedAnnotationValidation, executePagedAnnotationValidation, clearPagedAnnotationValidationExecution, previewLastPagedAnnotationValidationExecution, previewPublishedPagedAnnotationValidationExecution, downloadPagedAnnotationValidationExecution, downloadPublishedPagedAnnotationValidationExecution, publishPagedAnnotationValidation, unpublishPagedAnnotationValidation, deletePagedAnnotationValidation } from '../../utils/PagedAnnotationValidationAPI.js'
import { createFilterAnnotationValidation, updateFilterAnnotationValidation, deleteFilterAnnotationValidation, executeFilterAnnotationValidation, clearFilterAnnotationValidationExecution, previewLastFilterAnnotationValidationExecution, previewPublishedFilterAnnotationValidationExecution, downloadFilterAnnotationValidationExecution, downloadPublishedFilterAnnotationValidationExecution, publishFilterAnnotationValidation, unpublishFilterAnnotationValidation  } from '../../utils/FilterAnnotationValidationAPI.js'
import { createVocabularizer, deleteVocabularizer, executeVocabularizer, cleanupVocabularizer, vocabularyVocabularizer, publishVocabularizer, unpublishVocabularizer, viewVocabularizerExecution, getVocabulizers, indexVocabularizer, unindexVocabularizer } from '../../utils/VocabularizerAPI.js'
import { datasetAnnotationsStatistics } from '../../utils/DatasetUtils.js'
import { actionsMenu, toggleBoxColumn, sortByField, MessageQueue, parseResult } from '../../utils/UIUtils';

import { Localizer } from '../../config/localizer.js'
import { filterByLanguage } from "../../utils/functions.js";
import BarLoader from "react-spinners/BarLoader";
import { API_BASE_URL  } from '../../constants/index.js';

export class PublishedSchema extends Component {
  constructor(props) {
    super(props);

    this.state = {
      schema: [],
      topParents: [],
      schemaState: { loaded: false, loading:false, failed:false },

      annotators: [],
      annotationEditGroups: [],
      vocabularizers: [],
      valitations: [],
      indexes: {},

      embedders: [],
      clusterers: [],

      valuesModalShow: false,
      valuesModalControls: true,
      values: [],
      valuesEndpoint: null,
      valuesState: { loaded: false, loading:false, failed:false },

      itemValuesModalShow: false,
      itemValuesModalControls: true,
      itemValues: [],
      itemValueValue: null,
      itemValuesState: { loaded: false, loading:false, failed:false },

      annotationsModalShow: false,
      annotations: null,
      annotationsState: { loaded: false, loading:false, failed:false },

      clusteringsModalShow: false,
      clusterings: null,
      clusteringsState: { loaded: false, loading:false, failed:false },

      embeddingsModalShow: false,
      embeddings: null,
      embeddingsState: { loaded: false, loading:false, failed:false },

      annotationsEditModalShow: false,
      validationModalShow: false,
      annotationsEdit: [],
      annotationsEditFilter: { fields: [] },
      annotationsEditState: { loaded: false, loading:false, failed:false },
      annotationsEditOnProperty: null,
      annotationsEditOnPropertyPath: null,
      // annotationsEditGroup: null,
      // annotationsEditAsProperty: null,
      editGroupId: null,
      annotationsEditMode: "ALL",
      annotationsEditEnabled: false,

      clustersEditModalShow: false,
      clustersEdit: [],
      clustersEditState: { loaded: false, loading:false, failed:false },
      // annotationsEditGroup: null,
      // annotationsEditAsProperty: null,
      clustersEditEnabled: false,

      vocabularyEditModalShow: false,
      vocabulary: new Map(),

      annotationEditExecutionModalShow: false,
      annotationEditExecutions: [],
      annotationEditExecutionsState: { loaded: false, loading:false, failed:false },

      annotationValidations: {},
      annotationValidationsModalShow: false,
      annotationValidationsState: { loaded: false, loading:false, failed:false },

      validationProgress: {},

      annotationsDownloadModalShow:false,
      annotationsDownloadId: null,

      indexModalOpen: false,
    };

    this.messageQueueMap = new Map();
  }

  handlePublishMessage(field, message) {
      return {
        [field]: this.state[field].map(el => {
          if (el.id !== message.id) {
             return el
          } else {
            var obj = {...el, [message.type +'State']: message.content }

            return obj
          }
       })
      }
    }

  handleExecuteMessage(field, message) {
    return {
      [field]: this.state[field].map(el => {
        if (el.id !== message.id) {
           return el
        } else {
          var obj = {...el, [message.type +'State']: message.content }

          if (message.content.state == 'EXECUTED') {
            obj = {...obj, newExecution: true }
          }

          return obj
        }
     })
    }
  }

  handlePagedAnnotationOrFilteredAnnotationValidationsMessage(field, message) {
    // console.log("UPDATING " + message.order)
    return {
      annotationEditGroups: this.state.annotationEditGroups.map(el => {
        if (el.id !== message.instanceId) {
          return el
        } else {
          return {
            ...el, [field]: el[field].map(pav => {
              if (pav.id !== message.id) {
                return pav
              } else {
                var obj = {...pav, [message.type +'State']: message.content }

                if (message.content.state == 'EXECUTED') {
                  obj = {...obj, newExecution: true }
                }

                return obj
              }
            })
          }
        }
      })
    }
  }

  handleServerEvent(type, message) {
    // console.log(type);
    // console.log(message);
    if (type === 'filter_annotation_validation' || type === 'paged_annotation_validation') {
      var field;
      if (type === 'filter_annotation_validation') {
        field = 'filterAnnotationValidations'
      } else if (type === 'paged_annotation_validation') {
        field = 'pagedAnnotationValidations'
      }

      var id = message.id + ":" + message.type

      var queue = this.messageQueueMap.get(id)
      if (!queue) {
        queue = new MessageQueue(this, (message) => this.handlePagedAnnotationOrFilteredAnnotationValidationsMessage(field, message))
        this.messageQueueMap.set(id, queue)
      }

      queue.push(message)

      // if (message.type==='publish' || message.type === 'execute') {
      //   getAnnotationEditGroupsByUser(this.props.schemaDataset['@id'])
      //   .then(json => {this.setState({ annotationEditGroups: json })})
      // }

    } else if (type === 'annotator' || type === 'embedder' || type === 'clusterer' || type === 'clusterer-instance') {

      if (message.type === 'publish' || message.type === "execute") {
        var field = type + 's'
        var id = message.id + ":" + message.type

        var queue = this.messageQueueMap.get(id)
        if (!queue) {
          if (message.type === 'publish') {
            queue = new MessageQueue(this, (message) => this.handlePublishMessage(field, message))
          } else if (message.type === 'execute') {
            queue = new MessageQueue(this, (message) => this.handleExecuteMessage(field, message))
          }
          this.messageQueueMap.set(id, queue)
        }

        queue.push(message)
      }
    }
  }

componentDidMount() {
  this.showDataset(this.props);
}
componentWillReceiveProps(props) {
  if (props.schemaDataset === null) {
    this.setState({ schema: [], annotators: [], clusterers:[] })
  } else if (!this.props.schemaDataset || (this.props.schemaDataset.id !== props.schemaDataset.id)) {
    this.showDataset(props);
  }
}

showDataset(props) {
  // console.log(props)
  // // if (props.schemaDataset === null) {
  // //   this.setState({ schema: [], annotators: [], clusterers:[] })
  // // } else if (!this.props.schemaDataset || (this.props.schemaDataset.id !== props.schemaDataset.id)) {
  //   this.setState({ schemaState: { loaded: false, loading: true, failed: false}},
  //     () =>
  //     getDatasetSchema(props.schemaDataset.id)
  //       .then(response => {
  //
  //         // if(!response.hasOwnProperty('@graph')){
  //         //   this.setState({ topParents: [], schemaState: {loaded: true, loading: false, failed: false}})
  //         // } else {
  //         //   this.setState({ topParents: objectToArray(response['@graph'][0].classPartition), schema:response, schemaState: {loaded: true, loading: false, failed: false}});
  //         // }
  //         if (!response.data || !response.data[0].classPartition) {
  //           this.setState({ topParents: [], schemaState: {loaded: true, loading: false, failed: false}})
  //         } else {
  //           this.setState({ topParents: objectToArray(response.data[0].classPartition), schema:response, schemaState: {loaded: true, loading: false, failed: false}});
  //         }
  //     })
  //     .catch(error => {
  //     })
  //   )
  //
  //   // getAnnotatorsByUser(props.schemaDataset.id)
  //   getAnnotators(props.schemaDataset.id)
  //     .then(response => { this.setState({ annotators: response.data })})
  //     .catch(error => {})
  //
  //   this.getAnnotationEditGroupsByUser(props.schemaDataset.id)
  //
  //   getEmbeddersByUser(props.schemaDataset.id)
  //     .then(response => {this.setState({ embedders: response.data })})
  //     .catch(error => {})
  //
  //   getClusterers(props.schemaDataset.id)
  //     .then(response => {this.setState({ clusterers: response.data })})
  //     .catch(error => {})
  //
  //   // getVocabulizers(this.props.database.resourcePrefix + "dataset/" + props.schemaDataset.uuid)
  //   //   .then(json => {this.setState({ vocabularizers: json })})
  //
  //
  //   // this.messageQueueMap = new Map();
  // // }

   var _this = this;
   var promises = [];

   promises.push(
     new Promise(function(resolve, reject) {
       getDatasetSchema(props.schemaDataset.id)
         .then(response => {
           var stateUpdate;
           if (!response.data || !response.data[0].classPartition) {
             stateUpdate = { topParents: [], schema: undefined, schemaState: {loaded: true, loading: false, failed: false}}
           } else {
             stateUpdate = { topParents: objectToArray(response.data[0].classPartition), schema:response, schemaState: {loaded: true, loading: false, failed: false}}
           }
           _this.setState(stateUpdate, () => resolve())
         })
         .catch(error => {
           resolve()
         })
     })
   )

   promises.push(
     new Promise(function(resolve, reject) {
       getAnnotators(props.schemaDataset.id)
         .then(response => {
           _this.setState({ annotators: response.data }, () => resolve())
           resolve()
         })
         .catch(error => {
           // resolve()
         })
     })
   )

   promises.push(
     new Promise(function(resolve, reject) {
       getAnnotationEditGroupsByUser(props.schemaDataset.id)
         .then(response => {
           _this.setState({ annotationEditGroups: response.data }, () => resolve())
           // resolve()
         })
         .catch(error => {
           resolve()
         })
     })
   )

   promises.push(
     new Promise(function(resolve, reject) {
       getEmbeddersByUser(props.schemaDataset.id)
         .then(response => {
           _this.setState({ embedders: response.data }, () => resolve())
           // resolve()
         })
         .catch(error => {
           resolve()
         })
     })
   )

    promises.push(
      new Promise(function(resolve, reject) {
        getClusterers(props.schemaDataset.id)
          .then(response => {
            _this.setState({ clusterers: response.data }, () => resolve())
            // resolve()
          })
          .catch(error => {
            resolve()
          })
      })
    )


  this.setState({ schemaState: { loaded: false, loading: true, failed: false}}, () => {
    Promise.all(promises)
      .then(() => {

        if (!this.state.schema) {

          var classes = new Set();
          for (var x of this.state.annotators) {
            classes.add(x.onClass)
          }
          for (var x of this.state.embedders) {
            classes.add(x.onClass)
          }
          for (var x of this.state.clusterers) {
            classes.add(x.onClass)
          }

          var classesArray = Array.from(classes)
          classesArray.sort()

          var classPartition = []
          for (var x of classesArray) {
            classPartition.push({
              "type": "VOIDDataset",
              "class": x,
              "entities": 0
            })
          }

          var schema = { "success": true, "data": [ { "id": this.props.database.resourcePrefix + "dataset/" + props.schemaDataset.uuid,
                     "type": [ "VOIDDataset" ],
                     "title": props.schemaDataset.name,
                     classPartition
                   } ] }
          var stateUpdate = { topParents: objectToArray(schema.data[0].classPartition), schema:schema, schemaState: {loaded: true, loading: false, failed: false}}
          _this.setState(stateUpdate)

        }
      })
      .catch(error => {
      });
    })
}

getAnnotationEditGroupsByUser(datasetId) {
  getAnnotationEditGroupsByUser(datasetId)
    .then(response => {this.setState({ annotationEditGroups: response.data })})
    .catch(error => {})
}

  validationsSort(a,b) {
    if (a.name && b.name) {
         if (a.name < b.name) {
           return -1;
         } else if (a.name > b.name) {
           return 1;
         } else {
           return 0;
         }
    } else {
      if (a.id < b.id) {
        return -1;
      } else if (a.id > b.id) {
        return 1;
      } else {
        return 0;
      }
    }
  }

  updateAnnotatorInfo(params, response) {
    if (response.data) {
       this.setState({ annotators: this.state.annotators.map(el => el.id !== params.id ? el : response.data) })
    }
  }

  updateClustererInfo(params, response) {
    if (response.data) {
       this.setState({ clusterers: this.state.clusterers.map(el => el.id !== params.id ? el : response.data) })
    }
  }

  updateFilterAnnotationValidationInfo(params, response) {
    if (response.data) {
       this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id === params.aegId ?
         {...el , filterAnnotationValidations: el.filterAnnotationValidations.map(fav => fav.id === params.id ? response.data : fav) } : el ).sort(this.validationsSort) })
    }
  }

  updatePagedAnnotationValidationInfo(params, response) {
    if (response.data) {
      this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id === params.aegId ?
        {...el , pagedAnnotationValidations: el.pagedAnnotationValidations.map(pav => pav.id === params.id ? response.data : pav) } : el ).sort(this.validationsSort) })
    }
  }


  actions(action, params) {
      if (action === 'create-annotator') {
        if (params.id) {
          updateAnnotator(params.id, params.name, params.identifier, params.asProperty, params.tags, params.bodyProperties, params.datasetGroups, params.control, params.annotator, params.userAnnotator, params.thesaurus, params.parameters, params.preprocess, params.variant, params.defaultTarget, params.indexStructure, params.keysMetadata)
            .then((response) => {
              throwToast('success', response.message)
              this.setState({ annotators: this.state.annotators.map(el => el.id == params.id ? response.data : el) })
              this.getAnnotationEditGroupsByUser(this.props.schemaDataset.id)
            })
            .catch(error => {
            //   throwToast('error', error.message);
            })
        } else {
          createAnnotator(this.props.schemaDataset.id, params.name, params.identifier, params.onProperty, params.onClass, params.asProperty, params.tags, params.bodyProperties, params.datasetGroups, params.control, params.annotator, params.userAnnotator, params.thesaurus, params.parameters, params.preprocess, params.variant, params.defaultTarget, params.indexStructure, params.keysMetadata)
            .then((response) => {
              throwToast('success', response.message)
              this.setState({ annotators: this.state.annotators.slice().concat(response.data) })
              this.getAnnotationEditGroupsByUser(this.props.schemaDataset.id)
            })
            .catch(error => {
            //   throwToast('error', error.message);
            })
        }
      } else if (action === 'create-clusterer') {
          if (params.id) {
            updateClusterer(params.id, params.name, params.identifier, params.clusterer, params.userClusterer, params.annotatorTags, params.datasetGroups, params.parameters)
              .then((response) => {
                throwToast('success', response.message)
                this.setState({ clusterers: this.state.clusterers.map(el => el.id == params.id ? response.data : el) })
                // this.getAnnotationEditGroupsByUser(this.props.schemaDataset.id)
              })
              .catch(error => {
              //   throwToast('error', error.message);
              })
          } else {
            createClusterer(this.props.schemaDataset.id, params.name, params.identifier, params.onClass, params.clusterer, params.userClusterer, params.annotatorTags, params.datasetGroups, params.parameters)
              .then((response) => {
                throwToast('success', response.message)
                this.setState({ clusterers: this.state.clusterers.slice().concat(response.data) })
                // this.getAnnotationEditGroupsByUser(this.props.schemaDataset.id)
              })
              .catch(error => {
              //   throwToast('error', error.message);
              })
          }
      } else if (action === 'prepare-annotator') {
        prepareAnnotator(params.id)
          .then(response => {
            throwToast('success', response.message)
          })
          .catch(error => {
          //   throwToast('error', error.message)
          })
      } else if (action === 'execute-annotator') {
        executeAnnotator(params.id)
          .then(response => {
            throwToast('success', response.message)
          })
          .catch(error => {
          //   throwToast('error', error.message);
          })
       } else if (action === 'stop-annotator') {
         stopAnnotator(params.id)
          .then(response => {
             throwToast('success', response.message)
             this.updateAnnotatorInfo(params, response)
          })
          .catch(error => {
         //    throwToast('error', error.message);
         })
       } else if (action === 'delete-annotator') {
         this.setState({ deleteModalShow:true, deleteModalCommand: 'delete-annotator', deleteModalParams:params})
       } else if (action === 'delete-annotator-ok') {
         deleteAnnotator(params.id)
         .then(response => {
           throwToast('success', response.message)
           this.setState({ annotators: this.state.annotators.filter(el => el.id !== params.id)})
           this.getAnnotationEditGroupsByUser(this.props.schemaDataset.id)
         })
         .catch(error => {
         //   throwToast('error', error.message);
         })
       } else if (action === 'move-annotator') {
         changeAnnotatorOrder(params.id, params.step)
          .then(response => {
            this.setState({ annotators: response.data })
            // throwToast('success', response.message)
          })
          .catch(error => {
          //   throwToast('error', error.message);
          })
        } else if (action === 'move-clusterer') {
          changeClustererOrder(params.id, params.step)
           .then(response => {
             this.setState({ clusterers: response.data })
             // throwToast('success', response.message)
           })
           .catch(error => {
           //   throwToast('error', error.message);
           })
       } else if (action === 'execute-clusterer') {
         executeClusterer(params.id)
           .then(response => {
             throwToast('success', response.message)
           })
           .catch(error => {
           //   throwToast('error', error.message);
           })
        } else if (action === 'stop-clusterer') {
          stopClusterer(params.id)
           .then(response => {
              throwToast('success', response.message)
              this.updateClustererInfo(params, response)
           })
           .catch(error => {
          //    throwToast('error', error.message);
          })
        } else if (action === 'delete-clusterer') {
          this.setState({ deleteModalShow:true, deleteModalCommand: 'delete-clusterer', deleteModalParams:params})
        } else if (action === 'delete-clusterer-ok') {
          deleteClusterer(params.id)
          .then(response => {
            throwToast('success', response.message)
            this.setState({ clusterers: this.state.clusterers.filter(el => el.id !== params.id)})
          })
          .catch(error => {
          //   throwToast('error', error.message);
          })
      } else if (action === 'check-annotation-edit-group') {
        setAnnotationEditGroupAutoexportable(params.id, !this.state.annotationEditGroups.filter(el => el.id === params.id)[0].autoexportable)
          .then(response => {
            this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id !== params.id ? el : response.data)})
          })
          .catch(error => { })
      } else if (action === 'preview-last-annotator-execution') {
        this.setState({ annotations: null, annotationsModalShow:true, annotationsState: { loaded: false, loading: true, failed: false}}, () =>
          previewLastAnnotatorExecution(params.id)
            .then(response => {
              response.text().then(text => {
                var p = parseResult(text)
                // console.log(p);
                this.setState({ annotations: { type:'ANNOTATOR', mode:'LAST_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, annotationsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
                () => this.setState({ annotations: null, annotationsState: {loaded: false, loading: false, failed: true}}) )
          )
      } else if (action === 'preview-last-clusterer-execution') {
        this.setState({ clusterings: null, clusteringsModalShow:true, clusteringsState: { loaded: false, loading: true, failed: false}}, () =>
          previewLastClustererExecution(params.id)
            .then(response => {
              response.text().then(text => {
                var p = parseResult(text)
                // console.log(p);
                this.setState({ clusterings: { type:'CLUSTERER', mode:'LAST_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, clusteringsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
                () => this.setState({ clusterings: null, clusteringsState: {loaded: false, loading: false, failed: true}}) )
          )
        } else if (action === 'preview-last-clusterer-instance-execution') {
          this.setState({ clusterings: null, clusteringsModalShow:true, clusteringsState: { loaded: false, loading: true, failed: false}}, () =>
            previewLastClustererExecution(params.id)
              .then(response => {
                response.text().then(text => {
                  var p = parseResult(text)
                  // console.log(p);
                  this.setState({ clusterings: { type:'CLUSTERER', mode:'LAST_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, clusteringsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
                  () => this.setState({ clusterings: null, clusteringsState: {loaded: false, loading: false, failed: true}}) )
            )
      } else if (action === 'preview-published-annotator-execution') {
        this.setState({ annotations: null, annotationsModalShow:true, annotationsState: { loaded: false, loading: true, failed: false}}, () =>
          previewPublishedAnnotatorExecution(params.id)
            .then(response => {
              response.text().then(text => {
                var p = parseResult(text)
                this.setState({ annotations: { type:'ANNOTATOR', mode:'PUBLISHED_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, annotationsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
                () => this.setState({ annotations: null, annotationsState: {loaded: false, loading: false, failed: true}}) )
          )
        } else if (action === 'preview-published-clusterer-execution') {
          this.setState({ clusterings: null, clusteringsModalShow:true, clusteringsState: { loaded: false, loading: true, failed: false}}, () =>
            previewPublishedClustererExecution(params.id)
              .then(response => {
                response.text().then(text => {
                  var p = parseResult(text)
                  this.setState({ clusterings: { type:'CLUSTERER', mode:'PUBLISHED_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, clusteringsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
                  () => this.setState({ clusterings: null, clusteringsState: {loaded: false, loading: false, failed: true}}) )
            )
          } else if (action === 'preview-published-clusterer-instance-execution') {
            this.setState({ clusterings: null, clusteringsModalShow:true, clusteringsState: { loaded: false, loading: true, failed: false}}, () =>
              previewPublishedClustererExecution(params.id)
                .then(response => {
                  response.text().then(text => {
                    var p = parseResult(text)
                    this.setState({ clusterings: { type:'CLUSTERER', mode:'PUBLISHED_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, clusteringsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
                    () => this.setState({ clusterings: null, clusteringsState: {loaded: false, loading: false, failed: true}}) )
              )
      } else if (action === 'download-last-annotator-execution') {
        downloadLastAnnotatorExecution(params.id)
      } else if (action === 'download-last-clusterer-execution') {
        downloadLastClustererExecution(params.id)
      } else if (action === 'download-last-clusterer-clustering') {
        downloadLastClustererClustering(params.id, params.fileType)
      } else if (action === 'download-published-annotator-execution') {
        downloadPublishedAnnotatorExecution(params.id)
      } else if (action === 'download-published-clusterer-execution') {
        downloadPublishedClustererExecution(params.id)
      } else if (action === 'preview-annotator-execution') {
        this.setState({ annotationsEdit: null, annotationsEditAction: null, annotationsEditModalShow:true, annotationsEditState: { loaded: false, loading: true, failed: false}}, () =>
        previewAnnotator(params.id, params.page)
        .then(response => {
            // this.setState({ editGroupId: params.id, annotationsEdit: response.data, annotationsEditAction:action, annotationsEditPage: params.page, annotationsEditModalShow:true, annotationsEditMode: params.mode,
            this.setState({ editGroupId: params.id, annotationsEdit: response, annotationsEditAction:action, annotationsEditPage: params.page, annotationsEditModalShow:true, annotationsEditMode: params.mode,
              annotationsEditAnnotators: null, annotationsEditState: { loaded: true, loading: false, failed: false}})},
              () => this.setState({ annotationsEdit: null, annotationsEditState: {loaded: false, loading: false, failed: true}}) )
        .catch(error => { })
      )
    } else if (action === 'preview-annotator-clustering') {
      var uri = this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid

      if (params.lodview) {
        var xendpoint = API_BASE_URL + "/content/" + uri.substr(uri.lastIndexOf('/') + 1) + "/sparql"
      } else {
        xendpoint = null
      }
      this.setState({ clustersEdit: null, clustersEditModalShow:true, clustersEditState: { loaded: false, loading: true, failed: false}}, () =>
      previewAnnotatorClustering(params.id, params.page)
      .then(response => {
          this.setState({ editGroupId: params.id, clustersEdit: response.data, clustersEditPage: params.page, clustersEditModalShow:true, clustersEditEndpoint: xendpoint,
            clustersEditAnnotators: null, clustersEditState: { loaded: true, loading: false, failed: false}})},
            () => this.setState({ clustersEdit: null, clustersEditState: {loaded: false, loading: false, failed: true}}) )
      .catch(error => { })
    )
  } else if (action === 'preview-clusterer-execution') {
    var uri = this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid

    if (params.lodview) {
      var xendpoint = API_BASE_URL + "/content/" + uri.substr(uri.lastIndexOf('/') + 1) + "/sparql"
    } else {
      xendpoint = null
    }
    this.setState({ clustersEdit: null, clustersEditModalShow:true, clustersEditState: { loaded: false, loading: true, failed: false}}, () =>
    previewClustererExecution(params.id, params.page)
    .then(response => {
        this.setState({ editGroupId: params.id, clustersEdit: response.data, clustersEditPage: params.page, clustersEditModalShow:true, clustersEditEndpoint: xendpoint,
          clustersEditAnnotators: null, clustersEditState: { loaded: true, loading: false, failed: false}})},
          () => this.setState({ clustersEdit: null, clustersEditState: {loaded: false, loading: false, failed: true}}) )
    .catch(error => { })
  )
    } else if (action === 'clear-annotator-execution') {
      clearAnnotatorExecution(params.id)
        .then(response => {
           throwToast('success', response.message)
           this.updateAnnotatorInfo(params, response)
        })
        .catch(error => {
       //    throwToast('error', error.message);
       })
     } else if (action === 'clear-clusterer-execution') {
       clearClustererExecution(params.id)
         .then(response => {
            throwToast('success', response.message)
            this.updateClustererInfo(params, response)
         })
         .catch(error => {
        //    throwToast('error', error.message);
        })

    } else if (action === 'view-annotations') {
      this.setState({ annotationsEdit: null, annotationsEditAction:null, annotationsEditModalShow:true, annotationsEditState: { loaded: false, loading: true, failed: false}}, () =>
      viewValuesAnnotations(params.id, params.page, params.mode, params.annotators.map(an => an.uuid), params.filter)
      .then(json => {
          // this.setState({ editGroupId: params.id, annotationsEdit: json.data, annotationsEditAction:action, annotationsEditPage: params.page, annotationsEditModalShow:true, annotationsEditMode: params.mode,
          this.setState({ editGroupId: params.id, annotationsEdit: json, annotationsEditAction:action, annotationsEditPage: params.page, annotationsEditModalShow:true, annotationsEditMode: params.mode,
            annotationsEditFilter: params.filter, annotationsEditAnnotators: params.annotators, annotationsEditState: { loaded: true, loading: false, failed: false}})},
            () => this.setState({ annotationsEdit: null, annotationsEditState: {loaded: false, loading: false, failed: true}}) )
      .catch(error => {
      })
    )
  } else if (action === 'validate-annotations') {

// console.log(params.pav)
    this.setState({ annotationValidations: {}, annotationPav: null, annotationValidationsModalShow:true, annotationValidationsState: { loaded: false, loading: true, failed: false}}, () =>
    viewAnnotationValidation(params.pav.id, params.currentPage, params.mode, params.serial, params.navigation, params.requestedPage)
    .then(json => {
        this.setState({ annotationValidations: json, annotationPav: params.pav, annotationsEditOnProperty: params.onProperty, annotationsEditOnPropertyPath: params.onPropertyPath,  annotationsEditEnabled: params.edit, annotationValidationsModalShow:true, annotationValidationsState: { loaded: true, loading: false, failed: false}})},
          () => this.setState({ annotationValidations: {}, annotationPav: null, annotationValidationsState: {loaded: false, loading: false, failed: true}}) )
  )
} else if (action === 'export-annotations-modal') {
    this.setState( { annotationsDownloadModalShow: true, annotationsDownloadId: params.id, annotationsDownloadModalMode: "DOWNLOAD"} )
} else if (action === 'export-annotations-link-modal') {
      this.setState( { annotationsDownloadModalShow: true, annotationsDownloadId: null, annotationsDownloadModalMode: "LINK"} )
} else if (action === 'export-annotations') {
    // console.log(params);
    downloadAnnotationValues(params.id, params.format, params.onlyReviewed, params.onlyNonRejected, params.onlyFresh, params.created, params.creator, params.score, params.scope, params.selector, params.model, params.archive)
        .then((response) => {
          if (response.ok) {
            const filename = response.headers.get('content-disposition')
              .split(';')
              .find(n => n.includes('filename='))
              .replace('filename=', '')
              .trim();

              response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                  });
            } else {
               Promise.reject(response)
            } this.setState({annotationsDownloadModalShow: false}) },
            () => { Promise.reject(); this.setState({annotationsDownloadModalShow: false})})

  } else if (action === 'score-validation-distribution') {
      this.setState({ scoreDistribution: [], scoreDistributionModalShow: true, scoreDistributionState: { loaded: false, loading:true, failed:false }}, () =>
        scoreValidationDistribution(params.id, params.accuracy)
          .then(json => this.setState({ scoreDistribution: json, scoreDistributionState: { loaded: true, loading:false, failed:false } }),
                () => this.setState({ scoreDistribution: [], scoreDistributionState: { loaded: false, loading:false, failed:true } }),
        ))

  // } else if (action === 'publish-filter-validation') {
  //     publishFilterAnnotationValidation(params.id)
  // } else if (action === 'unpublish-filter-validation') {
  //     unpublishFilterAnnotationValidation(params.id)

  } else if (action === 'create-paged-validation') {
    if (params.id == null) {
      createPagedAnnotationValidation(params.aegId, params.name, params.mode, params.systemVocabularies, params.userVocabularies)
      .then(response => {
        throwToast('success', response.message)
        this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id === params.aegId ?
           {...el , pagedAnnotationValidations: el.pagedAnnotationValidations.slice().concat(response.data) } : el ).sort(this.validationsSort) })
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
    } else {
      updatePagedAnnotationValidation(params.id, params.name, params.mode, params.systemVocabularies, params.userVocabularies)
      .then(response => {
        throwToast('success', response.message)
        this.updatePagedAnnotationValidationInfo(params, response)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
    }
  } else if (action === 'create-filter-validation') {
    if (params.id == null) {
      createFilterAnnotationValidation(params.aegId, params.name, params.filters)
      .then(response => {
        throwToast('success', response.message)
        this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id === params.aegId ?
             {...el , filterAnnotationValidations: el.filterAnnotationValidations.slice().concat(response.data) } : el ).sort(this.validationsSort) })
      })
     .catch(error => {
     //   throwToast('error', error.message);
     })
    } else {
      updateFilterAnnotationValidation(params.id, params.name, params.filters)
      .then(response => {
        throwToast('success', response.message)
        this.updateFilterAnnotationValidationInfo(params, response)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
    }
  } else if (action === 'delete-paged-annotation-validation') {
    this.setState({ deleteModalShow:true, deleteModalCommand: 'delete-paged-annotation-validation', deleteModalParams:params})
  } else if (action === 'delete-paged-annotation-validation-ok') {
    deletePagedAnnotationValidation(params.id)
    .then(response => {
      throwToast('success', response.message)
      this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id === params.aegId ?
           {...el , pagedAnnotationValidations: el.pagedAnnotationValidations.filter(el => el.id !== params.id) } : el ) })
    })
    .catch(error => {
    //   throwToast('error', error.message);
    })

  } else if (action === 'delete-filter-annotation-validation') {
    this.setState({ deleteModalShow:true, deleteModalCommand: 'delete-filter-annotation-validation', deleteModalParams:params})
  } else if (action === 'delete-filter-annotation-validation-ok') {
    deleteFilterAnnotationValidation(params.id)
    .then(response => {
      throwToast('success', response.message)
      this.setState({ annotationEditGroups: this.state.annotationEditGroups.map(el => el.id === params.aegId ?
           {...el , filterAnnotationValidations: el.filterAnnotationValidations.filter(el => el.id !== params.id) } : el ) })
    })
    .catch(error => {
    //   throwToast('error', error.message);
    })
  } else if (action === 'execute-paged-annotation-validation') {
    executePagedAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'execute-filter-annotation-validation') {
    executeFilterAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'clear-paged-annotation-validation-execution') {
    clearPagedAnnotationValidationExecution(params.id)
      .then(response => {
         throwToast('success', response.message)
         this.updatePagedAnnotationValidationInfo(params, response)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'clear-filter-annotation-validation-execution') {
    clearFilterAnnotationValidationExecution(params.id)
      .then(response => {
         throwToast('success', response.message)
         this.updateFilterAnnotationValidationInfo(params, response)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'preview-paged-annotation-validation-execution') {
     this.setState({ annotationEditExecutions: null, annotationEditExecutionModalShow:true, annotationEditExecutionsState: { loaded: false, loading: true, failed: false}}, () =>
     previewLastPagedAnnotationValidationExecution(params.id)
     .then(response => {
         response.text().then(text => {
           var p = parseResult(text)
         this.setState({ annotationEditExecutions: { type:'PAGED_ANNOTATION', mode:'LAST_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, annotationEditExecutionsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
           () => this.setState({ annotationEditExecutions: null, annotationEditExecutionsState: {loaded: false, loading: false, failed: true}}) )
   )
   } else if (action === 'preview-filter-annotation-validation-execution') {
      this.setState({ annotationEditExecutions: null, annotationEditExecutionModalShow:true, annotationEditExecutionsState: { loaded: false, loading: true, failed: false}}, () =>
      previewLastFilterAnnotationValidationExecution(params.id)
      .then(response => {
          response.text().then(text => {
            var p = parseResult(text)
          this.setState({ annotationEditExecutions: { type:'FILTER_ANNOTATION', mode:'LAST_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, annotationEditExecutionsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
            () => this.setState({ annotationEditExecutions: null, annotationEditExecutionsState: {loaded: false, loading: false, failed: true}}) )
    )
   } else if (action === 'preview-published-paged-annotation-validation-execution') {
      this.setState({ annotationEditExecutions: null, annotationEditExecutionModalShow:true, annotationEditExecutionsState: { loaded: false, loading: true, failed: false}}, () =>
      previewPublishedPagedAnnotationValidationExecution(params.id)
      .then(response => {
          response.text().then(text => {
            var p = parseResult(text)
          this.setState({ annotationEditExecutions: { type:'PAGED_ANNOTATION', mode:'PUBLISHED_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, annotationEditExecutionsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
            () => this.setState({ annotationEditExecutions: null, annotationEditExecutionsState: {loaded: false, loading: false, failed: true}}) )
    )
  } else if (action === 'preview-published-filter-annotation-validation-execution') {
     this.setState({ annotationEditExecutions: null, annotationEditExecutionModalShow:true, annotationEditExecutionsState: { loaded: false, loading: true, failed: false}}, () =>
     previewPublishedFilterAnnotationValidationExecution(params.id)
     .then(response => {
         response.text().then(text => {
           var p = parseResult(text)
           this.setState({ annotationEditExecutions: { type:'FILTER_ANNOTATION', mode:'PUBLISHED_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, annotationEditExecutionsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
           () => this.setState({ annotationEditExecutions: null, annotationEditExecutionsState: {loaded: false, loading: false, failed: true}}) )
   )
 } else if (action === 'download-paged-annotation-validation-execution') {
   downloadPagedAnnotationValidationExecution(params.id)
 } else if (action === 'download-filter-annotation-validation-execution') {
     downloadFilterAnnotationValidationExecution(params.id)
 } else if (action === 'download-published-paged-annotation-validation-execution') {
     downloadPublishedPagedAnnotationValidationExecution(params.id)
 } else if (action === 'download-published-filter-annotation-validation-execution') {
     downloadPublishedFilterAnnotationValidationExecution(params.id)
  } else if (action === 'publish-paged-annotation-validation') {
    publishPagedAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'publish-filter-annotation-validation') {
    publishFilterAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'unpublish-paged-annotation-validation') {
    unpublishPagedAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'unpublish-filter-annotation-validation') {
    unpublishFilterAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'edit-annotation-validation') {
    // TODO
    // console.log(params);
    // editAnnotationValidation(params.id);
  } else if (action === 'stop-paged-annotation-validation') {
    stopPagedAnnotationValidation(params.id)
    .then(response => {
      throwToast('success', response.message)
      this.updatePagedAnnotationValidationInfo(params, response)
    })
    .catch(error => {
    //   throwToast('error', error.message);
    })
  } else if (action === 'resume-paged-annotation-validation') {
    resumePagedAnnotationValidation(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
  } else if (action === 'publish-annotator') {
      publishAnnotator(params.id)
        .then(response => {
           throwToast('success', response.message)
        })
        .catch(error => {
        //   throwToast('error', error.message);
         })

  } else if (action === 'unpublish-annotator') {
      unpublishAnnotator(params.id)
        .then(response => {
          throwToast('success', response.message)
        })
        .catch(error => {
        //   throwToast('error', error.message);
        })
  } else if (action === 'republish-annotator') {
      republishAnnotator(params.id)
        .then(response => {
           throwToast('success', response.message)
        })
        .catch(error => {
        //   throwToast('error', error.message);
         })
   } else if (action === 'publish-clusterer') {
       publishClusterer(params.id)
         .then(response => {
            throwToast('success', response.message)
         })
         .catch(error => {
         //   throwToast('error', error.message);
          })
   } else if (action === 'unpublish-clusterer') {
       unpublishClusterer(params.id)
         .then(response => {
           throwToast('success', response.message)
         })
         .catch(error => {
         //   throwToast('error', error.message);
         })
   } else if (action === 'republish-clusterer') {
       republishClusterer(params.id)
         .then(response => {
            throwToast('success', response.message)
         })
         .catch(error => {
         //   throwToast('error', error.message);
          })
  } else if (action === 'commit-annotation-edits') {
     commitAnnotationEdits(params.id, params.edits)
     // .then(response =>
       // this.setState({annotationsEditModalShow:false})
     // )
   } else if (action === 'commit-annotation-validation-page') {
     commitAnnotationValidationPage(params.pageid, params.edits, params.lockId)
     .then(response =>
       this.setState({ annotationValidations: {}, annotationValidationsModalShow:true, annotationValidationsState: { loaded: false, loading: true, failed: false}}, () =>
       viewAnnotationValidation(params.id, params.currentPage, params.mode, params.serial, params.navigation, params.requestedPage)
       .then(
         json => {
           if (json.errorMessage === "NO_PAGE_FOUND") {
             let obj = {
               currentPage: params.currentPage,
               data: [],
               errorMessage: json.errorMessage,
               filter: null,
               id: params.id,
               lockId: params.lockId,
               mode: params.mode.split('_')[0]+'_ONLY',
               pagedAnnotationValidationId: params.id,
               pagedAnnotationValidationPageId: params.pageid,
               totalPages: 0
             }
             this.setState({ annotationValidations: obj, annotationValidationsModalShow:true, annotationValidationsState: { loaded: true, loading: false, failed: false}});
           }
           else {
             this.setState({ annotationValidations: json, annotationValidationsModalShow:true, annotationValidationsState: { loaded: true, loading: false, failed: false}});
           }
         },
         () => this.setState({ annotationValidations: {}, annotationValidationsState: {loaded: false, loading: false, failed: true}}) )
     )
     )
   } else if (action === 'view-validation') {
       viewAnnotationEditsExecution(params.id)
       .then(response => {
        if (response.status === 204) {
          // this.setState({ lastExecution: { message: "The mapping has not been executed." }})
          return;
        } else if (!response.ok) {
         return "Error";
       } else {
         response.text().then(text =>
           this.setState({ annotationEditExecutions: { text: text }, annotationEditExecutionModalShow:true}))
       }
     })

     this.setState({ annotationEditExecutions: null, annotationEditExecutionModalShow:true, annotationEditExecutionsState: { loaded: false, loading: true, failed: false}}, () =>
     viewAnnotationEditsExecution(params.id)
     .then(response => {
         response.text().then(text =>
         this.setState({annotationEditExecutions: { text: text },
           annotationEditExecutionsState: { loaded: true, loading: false, failed: false}}))},
           () => this.setState({ annotationEditExecutions: null, annotationEditExecutionsState: {loaded: false, loading: false, failed: true}}) )
   )

  } else if (action === 'create-vocabularizer') {
    // console.log(params);
    // createVocabularizer(this.props.schemaDataset['@id'], params.onProperty, params.name, params.separator)
    createVocabularizer(this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid, params.onProperty, params.name, params.separator)
        .then((json) =>
            this.setState({ vocabularizers: this.state.vocabularizers.slice().concat(json) })
          )
  } else if (action === 'delete-vocabularizer') {
   deleteVocabularizer(params.id)
      .then(() =>
         this.setState({ vocabularizers: this.state.vocabularizers.filter(el => el.id !== params.id)}))
  } else if (action === 'execute-vocabularizer') {
     executeVocabularizer(params.id)
   } else if (action === 'view-vocabularizer-execution') {
     viewVocabularizerExecution(params.id)
     .then(response => {
      if (response.status === 204) {
        // this.setState({ lastExecution: { message: "The mapping has not been executed." }})
        return;
      } else if (!response.ok) {
       return "Error";
     } else {
       response.text().then(text =>
         this.setState({ annotations: { text: text }, annotationsModalShow:true}))
     }
   })
 } else if (action === 'publish-vocabularizer') {
       publishVocabularizer(params.id)
 } else if (action === 'unpublish-vocabularizer') {
        unpublishVocabularizer(params.id)
 } else if (action === 'index-vocabularizer') {
        indexVocabularizer(params.id)
 } else if (action === 'unindex-vocabularizer') {
       unindexVocabularizer(params.id)
 } else if (action === 'execute-cleanup-vocabularizer') {

   var promises = []

   var vocabulary;
   var equivalences;

   promises.push(
     new Promise(function(resolve, reject) {
       vocabularyVocabularizer(params.id)
         .then((json) =>  {
           vocabulary = json;
           resolve()
         })})
    )
   promises.push(
     new Promise(function(resolve, reject) {
       cleanupVocabularizer(params.id)
         .then((json) =>  {
           equivalences = json;
           resolve()
         })})
    )

     Promise.all(promises)
      .then(() => {
        var map = new Map();
        for (var i in vocabulary) {
          var set = []
          set.push({uri: vocabulary[i]['@id'], text: vocabulary[i]['http://www.w3.org/2000/01/rdf-schema#label'][0]['@value']});
          map.set(vocabulary[i]['@id'], set);
        }

        for (var i in equivalences) {
          for (var j in equivalences[i]) {
            if (j === '0') {
              var set = map.get(equivalences[i][j].uri);
            } else {
              set.push({uri: equivalences[i][j].uri, text: equivalences[i][j].text});
              map.set(equivalences[i][j].uri, set);
            }
          }
        }

        // console.log(map);
        this.setState({vocabulary: map, vocabularyEditModalShow: true})

     })
  } else if (action === 'show-values') {
       var uri = this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid

       if (params.lodview) {
         var xendpoint = API_BASE_URL + "/content/" + uri.substr(uri.lastIndexOf('/') + 1) + "/sparql"
       } else {
         xendpoint = null
       }
       if (params.path.length == 1 && params.path[0].type === 'CLASS') {
         var valuesModalControls = false;
       } else {
         valuesModalControls = true;
       }

       if (params.page == 1) {
         this.setState({ values: [], valuesMetadata: null, valuesPagination: null, valuesModalShow: true, valuesEndpoint: null, valuesPath: [], valuesMode: null, valuesState: { loaded: false, loading:true, failed:false }}, () =>
           getDatasetPropertyValues(this.props.schemaDataset.id, params.path, params.mode, params.page, params.size)
             .then(json => this.setState({ values: json.data, valuesMetadata: json.metadata, valuesPagination: json.pagination, valuesModalControls: valuesModalControls, valuesEndpoint: xendpoint, valuesPath: params.path, valuesMode: params.mode, valuesState: { loaded: true, loading:false, failed:false } }),
                   () => this.setState({ values: [], valuesMetadata: null, valuesPagination: null, valuesEndpoint: null, valuesPath: [], valuesMode: null, valuesState: { loaded: false, loading:false, failed:true } }),
           ))
       } else {
         this.setState({ valuesState: { loaded: true, loading:true, failed:false }}, () =>
           getDatasetPropertyValues(this.props.schemaDataset.id, params.path, params.mode, params.page, params.size)
             .then(json => this.setState({ values: this.state.values.concat(json.data), valuesMetadata: json.metadata, valuesPagination: json.pagination, valuesModalControls: valuesModalControls, valuesEndpoint: xendpoint, valuesPath: params.path, valuesMode: params.mode, valuesState: { loaded: true, loading:false, failed:false } }),
                   () => this.setState({ values: [], valuesMetadata: null, valuesPagination: null, valuesEndpoint: null, valuesPath: [], valuesMode: null, valuesState: { loaded: false, loading:false, failed:true } }),
           ))
       }
   } else if (action === 'download-values') {
     downloadDatasetPropertyValues(this.props.schemaDataset.id, params.path, params.mode)
     .then((response) => {
       if (response.ok) {
         const filename = response.headers.get('content-disposition')
           .split(';')
           .find(n => n.includes('filename='))
           .replace('filename=', '')
           .trim();

           response.blob().then(blob => {
       					let url = window.URL.createObjectURL(blob);
       					let a = document.createElement('a');
       					a.href = url;
       					a.download = filename;
       					a.click();
       				});
         } else {
            Promise.reject(response)
         }},
         () => Promise.reject())
   } else if (action === 'get-items-by-property-value') {
     // var uri = this.props.schemaDataset['@id']
     var uri = this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid
     var lodview = true;
     if (lodview) {
       var xendpoint = API_BASE_URL + "/content/" + uri.substr(uri.lastIndexOf('/') + 1) + "/sparql"
     } else {
       xendpoint = null
     }

     if (params.page == 1) {
      this.setState({ itemValues: [], itemValuesMetadata: null, itemValuesPagination: null, itemValuesValue: null, itemValuesEndpoint: null, itemValuesModalShow: true, itemValuesPath: [], itemValuesState: { loaded: false, loading:true, failed:false }}, () =>
        getDatasetPropertyValueItems(this.props.schemaDataset.id, params.path, params.value, params.page, params.size)
         .then(json => this.setState({ itemValues: json.data, itemValuesMetadata: json.metadata, itemValuesPagination: json.pagination, itemValuesValue: params.value, itemValuesEndpoint: xendpoint, itemValuesPath: params.path, itemValuesState: { loaded: true, loading:false, failed:false } }),
                () => this.setState({ itemValues: [], itemValuesMetadata: null, itemValuesPagination: null, itemValuesValue: null, itemValuesEndpoint: null, itemValuesPath: [], itemValuesState: { loaded: false, loading:false, failed:true } }),
        ))
      } else {
        this.setState({ itemValuesState: { loaded: true, loading:true, failed:false }}, () =>
          getDatasetPropertyValueItems(this.props.schemaDataset.id, params.path, params.value, params.page, params.size)
           .then(json => this.setState({ itemValues: this.state.itemValues.concat(json.data), itemValuesMetadata: json.metadata, itemValuesPagination: json.pagination, itemValuesValue: params.value, itemValuesEndpoint: xendpoint, itemValuesPath: params.path, itemValuesState: { loaded: true, loading:false, failed:false } }),
                  () => this.setState({ itemValues: [], itemValuesMetadata: null, itemValuesPagination: null, itemValuesValue: null, itemValuesEndpoint: null, itemValuesPath: [], itemValuesState: { loaded: false, loading:false, failed:true } }),
          ))
      }
   } else if (action === 'annotations-statistics') {
     // console.log(this.props.schemaDataset['@id'], params.onProperty, params.asProperty, params.annotator, params.thesaurus, params.parameters, params.preprocess, params.variant)
     datasetAnnotationsStatistics(this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid)
       .then((json) =>
          // this.setState({ annotators: this.state.annotators.slice().concat(json) })
          console.log(json)
       )
   } else if (action === 'create-embedder') {
      if (params.id == null) {
        // createEmbedder(this.props.schemaDataset['@id'], params.embedder, params.variant, params.indexStructure, params.onClass, params.keys)
        createEmbedder(this.props.schemaDataset.id, params.embedder, params.variant, params.indexStructure, params.onClass, params.keys)
        .then(response => {
          throwToast('success', response.message)
          this.setState({ embedders: this.state.embedders.slice().concat(response.data) })
        })
       .catch(error => {
       //   throwToast('error', error.message);
       })
      } else {
        // update
      }

   } else if (action === 'execute-embedder') {
     executeEmbedder(params.id)
      .then(response => {
        throwToast('success', response.message)
      })
      .catch(error => {
      //   throwToast('error', error.message);
      })
   } else if (action === 'stop-embedder') {
     stopEmbedder(params.id)
      .then(response => {
          throwToast('success', response.message);
          if (response.data) {
             this.setState({ embedders: this.state.embedders.map(el => el.id !== params.id ? el : response.data) })
          }
       })
       .catch(error => {
      //    throwToast('error', error.message);
      })
   } else if (action === 'delete-embedder') {
     this.setState({ deleteModalShow:true, deleteModalCommand: 'delete-embedder', deleteModalParams:params})
   } else if (action === 'delete-embedder-ok') {
     deleteEmbedder(params.id)
     .then(response => {
       throwToast('success', response.message)
       this.setState({ embedders: this.state.embedders.filter(el => el.id !== params.id) })
     })
     .catch(error => {
     //   throwToast('error', error.message);
     })
   } else if (action === 'publish-embedder') {
     publishEmbedder(params.id)
      .then(response => {
         throwToast('success', response.message)
        })
        .catch(error => {
        //   throwToast('error', error.message);
         })
   } else if (action === 'unpublish-embedder') {
      unpublishEmbedder(params.id)
       .then(response => {
          throwToast('success', response.message)
       })
       .catch(error => {
       //   throwToast('error', error.message);
        })
   } else if (action === 'preview-last-embedder-execution') {
      this.setState({ embeddings: null, embeddingsModalShow:true, embeddingsState: { loaded: false, loading: true, failed: false}}, () =>
        previewLastEmbedderExecution(params.id)
          .then(response => {
            response.text().then(text => {
              var p = parseResult(text)
              this.setState({ embeddings: { type:'EMBEDDER', mode:'LAST_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, embeddingsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
              () => this.setState({ embeddings: null, embeddingsState: {loaded: false, loading: false, failed: true}}) )
        )
    } else if (action === 'preview-published-embedder-execution') {
      this.setState({ embeddings: null, embeddingsModalShow:true, embeddingsState: { loaded: false, loading: true, failed: false}}, () =>
        previewPublishedEmbedderExecution(params.id)
          .then(response => {
            response.text().then(text => {
              var p = parseResult(text)
              this.setState({ embeddings: { type:'EMBEDDER', mode:'PUBLISHED_EXECUTION', id:params.id, text: p.text, lines: p.lines, shard: p.shard, nextLine: p.nextLine, file: p.file }, embeddingsState: {title:'Execution result', loaded: true, loading: false, failed: false} })})},
              () => this.setState({ embeddings: null, embeddingsState: {loaded: false, loading: false, failed: true}}) )
        )
    } else if (action === 'download-last-embedder-execution') {
      downloadLastEmbedderExecution(params.id)
        // .then((response) => {
        //   if (response.ok) {
        //     const filename = response.headers.get('content-disposition')
        //       .split(';')
        //       .find(n => n.includes('filename='))
        //       .replace('filename=', '')
        //       .trim();
        //
        //       response.blob().then(blob => {
        //   					let url = window.URL.createObjectURL(blob);
        //   					let a = document.createElement('a');
        //   					a.href = url;
        //   					a.download = filename;
        //   					a.click();
        //   				});
        //     } else {
        //        Promise.reject(response)
        //     }},
        //     () => Promise.reject())
    } else if (action === 'download-published-embedder-execution') {
      downloadPublishedEmbedderExecution(params.id)
        // .then((response) => {
        //   if (response.ok) {
        //     saveDownloadedFile(response);
        //     const filename = response.headers.get('content-disposition')
        //       .split(';')
        //       .find(n => n.includes('filename='))
        //       .replace('filename=', '')
        //       .trim();
        //
        //       response.blob().then(blob => {
        //   					let url = window.URL.createObjectURL(blob);
        //   					let a = document.createElement('a');
        //   					a.href = url;
        //   					a.download = filename;
        //   					a.click();
        //   				});
        //     } else {
        //        Promise.reject(response)
        //     }},
        //     () => Promise.reject())
    }
}

  render() {

    // var index = this.props.indexes.filter(el => el.onProperty[0] === this.props.value['@id']);
    // if (index.length > 0) {
    //   index = index[0]
    // } else {
    //   index = null
    // }

    // var index;
    // var indexed = false;
    // if (Object.keys(this.state.indexes).length) {
    //   index = this.state.indexes;
    //   indexed = true;
    // } else {
    //   index = { indexState : "NOT_INDEXED" }
    // }

    // var control = { '@id': 'control' };

    // console.log(this.state.annotators)

    // let context = this.state.schema['@context'];
    var context;
    // var fullView = this.props.mode === 'EDITOR';
    var fullView = true;

    return (
      <div>
        {this.props.schemaDataset &&


          <Container className="userspace-right">
            <Row className=" userspace-right-inner">
              <Col>



        <Container className="groupborder">
          <Row className="header">
            <Col md={11} className="bold">
              {this.props.type==='DATASET' && <span className="crimson-std">Dataset: </span>}
              {this.props.type==='CATALOG' && <span className="crimson-std">Catalog: </span>}
              {this.props.type==='SCHEMA' && <span className="crimson-std">Schema: </span>}
               {this.props.schemaDataset.name}
            </Col>

            <Col className="mybutton" md={1}>
              <DropdownButton size="sm" title={<span title="Actions" className='fa fa-bars'></span>} className="actions">

                {false && // annotation statistics implementation has not beem completed
                <Dropdown.Item className="py-2" onClick={() => this.actions('annotations-statistics')}>
                  <span className="menu-icon fa fa-signal fa-lg mr-3"></span>Annotation statistics...
                </Dropdown.Item>}

                <Dropdown.Item className="py-2" onClick={() => this.actions('export-annotations-link-modal', {})}>
                  <span className="menu-icon fa fa-clipboard fa-lg mr-3" />Get annotations download link...
                </Dropdown.Item>
              </DropdownButton>

            </Col>
          </Row>

          {this.state.schemaState.loading &&
          <Row>
            <Col className="loader">
              <BarLoader css='spinner' height={6} width={600} color='crimson' loading={true}/>
            </Col>
          </Row>}

          {this.state.schemaState.failed &&
          <Row>
            <Col>
              {/*<span className="error">Loading {filterByLanguage(this.props.schemaDataset,'http://purl.org/dc/terms/title', Localizer.language)} failed.</span>*/}
              <span className="error">Loading {this.props.schemaDataset.name} failed.</span>
            </Col>
          </Row>}

          {/*this.state.schemaState.loaded && this.state.topParents.length === 0 &&
          <div className="text-center text-danger">
            <i className="fa fa-exclamation-triangle fa-lg mr-3" aria-hidden="true"></i>
            <span><strong>Empty schema.</strong></span>
          </div>
          */}

          {this.state.schemaState.loaded && this.state.topParents.sort((a,b) => sortByField('class', a, b)).map((el,index) =>
          <SchemaClass  key={index} value={el}
                    dataset={this.props.schemaDataset}
                    datasetUri={this.props.database.resourcePrefix + "dataset/" + this.props.schemaDataset.uuid}
                    // schema={this.state.schema}
                    // mode={this.props.mode}
                    my={this.props.my}
                    language={this.props.language}
                    annotators={this.state.annotators}
                    annotationEditGroups={this.state.annotationEditGroups}
                    validationProgress={this.state.validationProgress}
                    vocabularizers={this.state.vocabularizers}
                    embedders={this.state.embedders}
                    clusterers={this.state.clusterers}
                    // indexes={this.state.indexes}
                    queryProperties={this.props.queryProperties}
                    dataAnnotators={this.props.dataAnnotators}
                    userAnnotators={this.props.userAnnotators}
                    dataEmbedders={this.props.dataEmbedders}
                    // dataClusterers={this.props.dataClusterers} // legacy
                    userClusterers={this.props.userClusterers}
                    preprocessFunctions={this.props.preprocessFunctions}
                    preprocessOperations={this.props.preprocessOperations}
                    // vocabularies={this.props.vocabularies}
                    project={this.props.project}
                    rdfVocabularies={this.props.rdfVocabularies}
                    validationModes={this.props.validationModes}
                    actions={(action, params) => this.actions(action, params)}/>)}

        {this.state.valuesModalShow &&
        <PropertyValuesModal show={this.state.valuesModalShow}
                             type='VALUES'
                             values={this.state.values}
                             metadata={this.state.valuesMetadata}
                             pagination={this.state.valuesPagination}
                             state={this.state.valuesState}
                             endpoint={this.state.valuesEndpoint}
                             database={this.props.database}
                             path={this.state.valuesPath}
                             mode={this.state.valuesMode}
                             dataset = {this.state.schemaDataset}
                             language={this.props.language}
                             controls={this.state.valuesModalControls}
                             actions={(action, params) => this.actions(action, params)}
                             onClose={() => this.setState({ valuesModalShow: false })}/>}

         {this.state.itemValuesModalShow &&
         <PropertyValuesModal show={this.state.itemValuesModalShow}
                              type='ITEMS'
                              value= {this.state.itemValuesValue}
                              values={this.state.itemValues}
                              metadata={this.state.itemValuesMetadata}
                              pagination={this.state.itemValuesPagination}
                              state={this.state.itemValuesState}
                              endpoint={this.state.itemValuesEndpoint}
                              database={this.props.database}
                              path={this.state.itemValuesPath}
                              dataset = {this.state.schemaDataset}
                              language={this.props.language}
                              actions={(action, params) => this.actions(action, params)}
                              onClose={() => this.setState({ itemValuesModalShow: false })}/>}

       {/*this.state.scoreDistributionModalShow &&
        <ScoreDistributionModal show={this.state.scoreDistributionModalShow}
                            distributions={this.state.scoreDistribution}
                            state={this.state.scoreDistributionState}
                            language={this.props.language}
                            onClose={() => this.setState({ scoreDistributionModalShow: false })}/>*/}

        {this.state.annotationsModalShow &&
        <ResultsModal show={this.state.annotationsModalShow}
                      state={this.state.annotationsState}
                      execution={this.state.annotations}
                      onClose={() => this.setState({ annotationsModalShow: false })}/>}

        {this.state.clusteringsModalShow &&
        <ResultsModal show={this.state.clusteringsModalShow}
                      state={this.state.clusteringsState}
                      execution={this.state.clusterings}
                      onClose={() => this.setState({ clusteringsModalShow: false })}/>}

        {this.state.embeddingsModalShow &&
        <ResultsModal show={this.state.embeddingsModalShow}
                      state={this.state.embeddingsState}
                      execution={this.state.embeddings}
                      onClose={() => this.setState({ embeddingsModalShow: false })}/>}

        {this.state.annotationEditExecutionModalShow &&
        <ResultsModal show={this.state.annotationEditExecutionModalShow}
                      state={this.state.annotationEditExecutionsState}
                      execution={this.state.annotationEditExecutions}
                      onClose={() => this.setState({ annotationEditExecutionModalShow: false })}/>}

        {this.state.annotationsEditModalShow &&
        <AnnotationValuesModal show={this.state.annotationsEditModalShow}
                             state={this.state.annotationsEditState}
                             values={this.state.annotationsEdit}
                             filter={this.state.annotationsEditFilter}
                             onProperty={this.state.annotationsEditOnProperty}
                             asProperty={this.state.annotationsEditAsProperty}
                             mode={this.state.annotationsEditMode}
                             page={this.state.annotationsEditPage}
                             id={this.state.editGroupId}
                             action={this.state.annotationsEditAction}
                             // dataAnnotators={this.props.dataAnnotators}
                             annotators={this.state.annotationsEditAnnotators}
                             language={this.props.language}
                             // edits={this.annotationEdits}
                             actions={(action, params) => this.actions(action, params)}
                             onClose={() => this.setState({ annotationsEditModalShow: false })}/>}

         {this.state.clustersEditModalShow &&
         <ClusterValuesModal show={this.state.clustersEditModalShow}
                             database={this.props.database}
                              state={this.state.clustersEditState}
                              values={this.state.clustersEdit}
                              endpoint={this.state.clustersEditEndpoint}
                              page={this.state.clustersEditPage}
                              id={this.state.editGroupId}
                              actions={(action, params) => this.actions(action, params)}
                              onClose={() => this.setState({ clustersEditModalShow: false })}/>}

         {this.state.annotationValidationsModalShow &&
         <ValidationModal
                dataset={this.props.schemaDataset}
                mode='EDITOR'
                show={this.state.annotationValidationsModalShow}
                state={this.state.annotationValidationsState}
                value={this.state.annotationValidations}
                pav={this.state.annotationPav}
                edit={this.state.annotationsEditEnabled}
                onProperty={this.state.annotationsEditOnProperty}
                onPropertyPath={this.state.annotationsEditOnPropertyPath}
                datasetName={this.props.schemaDataset.name}
                // asProperty={this.state.annotationsEditAsProperty}
                // mode={this.state.annotationsEditMode}
                // page={this.state.annotationsEditPage}
                // id={this.state.editGroupId}
                // annotators={this.state.annotationsEditAnnotators}
                language={this.props.language}
                rdfVocabularies={this.props.rdfVocabularies}
                actions={(action, params) => this.actions(action, params)}
                onClose={() => this.setState({ annotationValidationsModalShow: false })}/>}

         {this.state.vocabularyEditModalShow &&
          <VocabularyValuesModal show={this.state.vocabularyEditModalShow}
                              value={this.state.vocabulary}
                              // onProperty={this.state.annotationsEditProperty}
                              // asProperty={this.state.annotationsAsProperty}
                              // id={this.state.editGroupId}
                              // edits={this.annotationEdits}
                              actions={(action, params) => this.actions(action, params)}
                              onClose={() => this.setState({ vocabularyEditModalShow: false })}/>}

          {this.state.deleteModalShow &&
          <DeleteModal show={this.state.deleteModalShow}
                       command={this.state.deleteModalCommand}
                       params={this.state.deleteModalParams}
                      actions={(choice, command, params) => { this.setState( {deleteModalShow:false }); return (choice === 'ok' ? this.actions(command + '-ok', params): null)} }/>}


          {this.state.annotationsDownloadModalShow &&
          <DownloadAnnotationsModal
              show={this.state.annotationsDownloadModalShow}
              id={this.state.annotationsDownloadId}
              dataset={this.props.schemaDataset}
              mode={this.state.annotationsDownloadModalMode}
              actions={(action, params) => {this.actions(action, params)}}
              onClose={() => this.setState({ annotationsDownloadModalShow: false })}/>}
        </Container>
</Col></Row></Container>

      }
      </div>
    );
  }
}



export default PublishedSchema;
